/*
 * 記事本文の画像をクリックで拡大表示する(sections/article-main.liquid から読み込み)。
 * - JPG等(Shopify CDN): 拡大時は高解像度版を読み込む
 * - SVG: ベクターなので画面いっぱいに拡大しても鮮明
 * 拡大中に画像をクリック/タップすると、さらに2倍表示(スクロールで移動)に切り替わる。
 */
(function () {
  var body = document.querySelector('.article__body');
  if (!body || typeof HTMLDialogElement === 'undefined') return;

  var images = Array.prototype.filter.call(body.querySelectorAll('img'), function (img) {
    return !img.closest('a'); // リンク付き画像はリンクを優先する
  });
  if (!images.length) return;

  var dialog = document.createElement('dialog');
  dialog.className = 'article-lightbox';
  dialog.setAttribute('aria-label', '画像の拡大表示');
  dialog.innerHTML =
    '<button type="button" class="article-lightbox__close" aria-label="閉じる">&times;</button>' +
    '<div class="article-lightbox__stage"><img class="article-lightbox__img" alt=""></div>' +
    '<p class="article-lightbox__hint">画像をタップするとさらに拡大できます</p>';
  document.body.appendChild(dialog);

  var stage = dialog.querySelector('.article-lightbox__stage');
  var big = dialog.querySelector('.article-lightbox__img');

  function largeSrc(src) {
    // SVGはそのまま。Shopify CDNのラスター画像は width=2000 で取り直す
    if (/\.svg(\?|$)/i.test(src)) return src;
    if (/cdn\.shopify\.com|\/cdn\/shop\//.test(src)) {
      var url = new URL(src, location.href);
      url.searchParams.set('width', '2000');
      url.searchParams.delete('height');
      url.searchParams.delete('crop');
      return url.toString();
    }
    return src;
  }

  function open(img) {
    big.src = largeSrc(img.currentSrc || img.src);
    big.alt = img.alt || '';
    dialog.classList.remove('is-zoomed');
    dialog.showModal();
    document.documentElement.classList.add('is-lightbox-open');
  }

  function close() {
    dialog.close();
  }

  dialog.addEventListener('close', function () {
    document.documentElement.classList.remove('is-lightbox-open');
    big.removeAttribute('src');
  });

  images.forEach(function (img) {
    img.classList.add('is-zoomable');
    img.setAttribute('tabindex', '0');
    img.setAttribute('role', 'button');
    img.setAttribute('aria-label', (img.alt ? img.alt + ' ' : '') + '(クリックで拡大)');
    img.addEventListener('click', function () { open(img); });
    img.addEventListener('keydown', function (e) {
      if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(img); }
    });
  });

  dialog.querySelector('.article-lightbox__close').addEventListener('click', close);

  // 画像以外(背景)をクリックしたら閉じる
  dialog.addEventListener('click', function (e) {
    if (e.target === dialog || e.target === stage) close();
  });

  // 画像クリックで「画面に収める」⇔「2倍表示」を切り替え。2倍時はクリック位置が中央に来るようにする
  big.addEventListener('click', function (e) {
    var zoomed = dialog.classList.toggle('is-zoomed');
    if (zoomed) {
      var rect = big.getBoundingClientRect();
      var rx = (e.clientX - rect.left) / rect.width;
      var ry = (e.clientY - rect.top) / rect.height;
      requestAnimationFrame(function () {
        stage.scrollLeft = big.offsetWidth * rx - stage.clientWidth / 2;
        stage.scrollTop = big.offsetHeight * ry - stage.clientHeight / 2;
      });
    }
  });
})();
